import { z } from 'zod';

export const schema = z.object({
  username: z.string().trim(),
  password: z.string().trim(),
});

export type LoginSchemaType = z.infer<typeof schema>;
